import { QuestionProps } from '@/models/Question';

import IntegerQuestionType from './Integer';

function PopulationQuestionType({ question }: { question: QuestionProps }) {
  return <IntegerQuestionType question={question} />;
}

export default PopulationQuestionType;
